import { render } from "./Basictable.vue?vue&type=template&id=2205f64a"
import script from "./Basictable.vue?vue&type=script&lang=js"
export * from "./Basictable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__